module.exports = __webpack_public_path__ + "static/63-c713df631abb6b292e936396b7164219.png";